/* eslint-disable */

export class LoopFrequency {
  private loopTimer: null | number = null;
  private frequency = 0;
  private handle: null | ((instance: LoopFrequency) => void) = null;
  public constructor(
    frequency: number,
    handle: (instance: LoopFrequency) => void
  ) {
    this.frequency = frequency;
    this.handle = handle;
    this.start();
  }

  private start() {
    this.loopTimer = window.setInterval(() => {
      if (this.handle) {
        this.handle(this);
      }
    }, this.frequency);
  }

  public stop() {
    if (this.loopTimer) {
      window.clearInterval(this.loopTimer);
    }
  }

  public destroy() {
    if (this.loopTimer) {
      window.clearInterval(this.loopTimer);
      this.loopTimer = null;
    }
  }
}
